import {
  Button,
  Typography,
  Snackbar,
  Grid,
  Stack,
} from '@mui/material';
import React, { useState } from 'react';
import { useMutation } from '@apollo/client';
import PropTypes from 'prop-types';
import HelpTextField from '../fields/HelpTextField';
import { HELP_CENTER_EMAIL } from '../../graphql/mutations';

function HelpCenterForm({
  nameLabel,
  phoneNumberLabel,
  emailLabel,
  questionLabel,
  buttonText,
  messageInputText,
  maxWidth,
}) {
  const [HelpCenterMail] = useMutation(HELP_CENTER_EMAIL, {
    onCompleted: () => {},
  });
  const [notificationMessage, setNotificationMessage] = useState('');
  const [openNotification, setOpenNotification] = useState(false);
  const [formInputs, setFormInputs] = useState({
    name: '',
    email: '',
    phoneNumber: '',
    question: '',
  });
  const notEmptyValidation = () => {
    let ret = true;
    Object.entries(formInputs).forEach((key) => {
      if (key[0] !== 'phoneNumber') {
        ret = ret && key[1] !== '';
      }
    });
    return !ret;
  };

  const showInvalidFormNotification = () => {
    setNotificationMessage('Debes completar los campos obligatorios');
    setOpenNotification(true);
  };

  const showSuccessNotification = () => {
    setNotificationMessage('¡Recibimos tu mensaje con éxito!');
    setOpenNotification(true);
  };

  const onChange = (e) => {
    const { name, value } = e.target;
    setFormInputs((oldstate) => ({
      ...oldstate,
      [name]: value,
    }));
  };

  const onSend = () => {
    if (notEmptyValidation()) {
      showInvalidFormNotification();
      return;
    }
    const fullMessage = messageInputText
      ? `${messageInputText}: ${formInputs.question}`
      : formInputs.question;
    HelpCenterMail({
      variables: {
        name: formInputs.name,
        email: formInputs.email,
        phoneNumber: formInputs.phoneNumber,
        message: fullMessage,
      },
    });
    setFormInputs({ name: '', email: '', phoneNumber: '', question: '' });
    showSuccessNotification();
  };
  return (
    <Stack
      sx={{
        display: 'flex',
        width: '100%',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-start',
        gap: '1.625rem',
        maxWidth,
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <HelpTextField
            value={formInputs.name}
            onChange={onChange}
            label={nameLabel}
            type="text"
            name="name"
            required
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <HelpTextField
            value={formInputs.phoneNumber}
            onChange={onChange}
            label={phoneNumberLabel}
            type="number"
            name="phoneNumber"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <HelpTextField
            value={formInputs.email}
            onChange={onChange}
            label={emailLabel}
            type="email"
            name="email"
            required
          />
        </Grid>
        <Grid item xs={12}>
          <HelpTextField
            value={formInputs.question}
            onChange={onChange}
            label={questionLabel}
            type="text"
            name="question"
            multiline
            height="10rem"
            required
          />
        </Grid>
      </Grid>
      <Button
        id="help-center-form-button"
        aria-label="Enviar mensaje"
        variant="newPrimary"
        onClick={onSend}
        sx={{ width: '100%' }}
      >
        <Typography
          variant="medium_2"
          color="white"
          fontWeight={600}
          fontSize={{ xs: '1.125rem', ipad: '1.125rem' }}
        >
          {buttonText}
        </Typography>
      </Button>
      <Snackbar
        open={openNotification}
        autoHideDuration={6000}
        onClose={() => setOpenNotification(false)}
        message={notificationMessage}
      />
    </Stack>
  );
}

HelpCenterForm.propTypes = {
  nameLabel: PropTypes.string.isRequired,
  phoneNumberLabel: PropTypes.string.isRequired,
  emailLabel: PropTypes.string.isRequired,
  questionLabel: PropTypes.string,
  buttonText: PropTypes.string.isRequired,
  messageInputText: PropTypes.string,
  maxWidth: PropTypes.string,
};

HelpCenterForm.defaultProps = {
  questionLabel: 'Mensaje',
  messageInputText: '',
  maxWidth: '100%',
};

export default HelpCenterForm;
